// third-party
import { combineReducers } from "redux";

// project import
import menu from "./menu";
import auth from "./auth";
import search from "./search";
import dashboardValue from "./dashboardValue";
import recordView from "./recordView";
import accessControl from "./accessControl";
import maindashboard from "./maindashboard";
import loginShow from "./loginShow";
import otpShow from "./otpValueShow";
import forgotPasswordShow from "./forgotPassword";
import setpasswordShow from "./setpasswordshow";
import notification_refresh from "./notification_refresh";
import company_profile from "./company_profile";
import tab_number from "./tabNumber";
import ingredients from "./ingredients";
import submit_status from "./submit_status";
import newProcessData from "./newProcessData";
import editOpDag from "./editOperationDag";
import moduleView from "./useModule";
import testProdView from "./testProdSelect";
import lang from "./lang";
import processConfig from "../../pages/Batch-Processing/mbmr/slice/processConfig";
import recipeconfigrefresh from "./recipeConfigRefresh";
import workflowData from "./workflowData";
import workflowNode from "./workflowNode";
import checklistData from "./checklistData";
import checklistNode from "./checklistNode";
import workflowSectionStatus from "./workflowSectionStatus";
import headerContent from "./headerContent";
import ingredientQty from "./ingredientQty";
import moduleSelectionReducer from "../../components/FloatingChatPackage/store/slices/moduleSelectionSlice";

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  auth,
  search,
  dashboardValue,
  recordView,
  forgotPasswordShow,
  accessControl,
  maindashboard,
  otpShow,
  loginShow,
  setpasswordShow,
  notification_refresh,
  company_profile,
  tab_number,
  ingredients,
  submit_status,
  newProcessData,
  moduleView,
  editOpDag,
  testProdView,
  lang,
  processConfig,
  recipeconfigrefresh,
  workflowData,
  workflowNode,
  checklistData,
  checklistNode,
  workflowSectionStatus,
  headerContent,
  ingredientQty,
  moduleSelection: moduleSelectionReducer,
});

export default reducers;
